import _ from 'lodash';

const Compliance = {
  isAsaCompliant: text => {
    const asaTags = ['#ad', '#spon', '#partner', '\\bad\\b'];
    const asaRegex = new RegExp(_.join(asaTags, '|'), 'ig');
    const isCompliant = asaRegex.test(text);
    return isCompliant;
  },
};

module.exports = {
  Compliance,
};



/** WEBPACK FOOTER **
 ** ./src/utils/compliance.js
 **/